import {createRouter, createWebHashHistory} from 'vue-router';
import store from './store';
import LoginService from './service/LoginService'
import { getListPublicUsers } from "./service/UsersService";
let loginService = new LoginService();
const secret = "24432646294A404D635166546A576E5A7234753778214125442A472D4B6150645267556B58703273357638792F423F4528482B4D6251655468566D5971337436";
const passwd = "Reply.96!"
const routes = [
    {
        path: '/',
        name: 'dashboard',
        exact: true,
        component: () => import('./components/Dashboard.vue'),
        redirect: "/recipes",
        meta: {
            requiresAuth: true
        },
    },// /recipes/aperitivi/3 -> recipes < Aperitivi < Polenta
    {
        path: '/products',
        name: 'products',
        exact: true,
        component: () => import('./pages/Products.vue'),
        meta: {
            requiresAuth: true
        },
    },
    {
        path: '/appliances',
        name: 'appliances',
        exact: true,
        component: () => import('./pages/Appliances.vue'),
        meta: {
            requiresAuth: true
        },
       
    },
    {
        path: '/appliances/:id',
        name: 'appliance',
        exact: true,
        component: () => import('./pages/Appliance.vue'),
        meta: {
            requiresAuth: true
        },
       
    },
    {
        path: '/appliances/:id/all_recipes',
        name: 'all_appliances',
        component: () => import('./pages/AllRecipes.vue'),
        meta: {
            requiresAuth: true

        },
    },
    {
        path: '/recipes',
        name: 'recipes',
        component: () => import('./pages/Recipes.vue'),
        exact: true,
        meta: {
            requiresAuth: true,
        },
    },  
    {
        path: '/recipes/:category',
        name: 'recipeCategory',
        component: () => import('./pages/RecipeCategory.vue'),
        meta: {
            requiresAuth: true,
            breadcrumbs: [
                {name: 'recipes'},
            ]
        },
    },
    {
        path: '/recipes/:category/:id',
        name: 'singleRecipe',
        component: () => import('./pages/SingleRecipe.vue'),
        meta: {
            requiresAuth: true,
            breadcrumbs: [
                { url: 'recipes', toTranslate: false },
                { url: 'recipeCategory', toTranslate: false },
            ]
        },
    },
    {
        path: '/upload-recipe',
        name: 'uploadRecipe',
        meta: { requiresUnauth: true },
        component: () => import('./pages/UploadRecipe.vue')
    },
    {
        path: '/my-recipes',
        name: 'myRecipes',
        meta: { requiresUnauth: true },
        component: () => import('./pages/MyRecipes.vue')
    },
    {
        path: '/liked-recipes',
        name: 'likedRecipes',
        meta: { requiresUnauth: true },
        component: () => import('./pages/LikedRecipes.vue')
    },
    {
        path: '/storage',
        name: 'storage',
        exact: true,
        component: () => import('./pages/Storage.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'Dashboard' }],
            requiresAuth: true
        },
    },
    {

        path: '/storage/:type',
        name: 'singleStorage',
        component: () => import('./pages/SingleStorage.vue'),
        meta: {
            breadcrumb: [{ parent: 'storages', label: 'Specific Storage' }],
            requiresAuth: true
        }
    },
    {
        path: '/assistance',
        name: 'assistance',
        meta: { requiresUnauth: true },
        component: () => import('./pages/Assistance.vue')
    },
    {
        path: '/tickets',
        name: 'tickets',
        meta: { requiresUnauth: true },
        component: () => import('./pages/Tickets.vue')
    },
    {
        path: '/tickets/:uid',
        name: 'singleTicket',
        component: () => import('./pages/SingleTicket.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/profile',
        name: 'profile',
        component: () => import('./pages/Profile.vue'),
        exact: true,
        meta: {
            breadcrumb: [{ parent: 'profile', label: 'Profile' }],
            requiresAuth: true
        },
        children: [
            {
                path: 'info',
                name: 'infoProfile',
                component: () => import('./components/Profile/Info.vue'),
                meta: {
                    breadcrumb: [{ parent: 'profile', label: 'Info' }],
                    requiresAuth: true
                }
            }
        ],  
    },
    {
        path: '/activity',
        name: 'activity',
        meta: { requiresUnauth: true },
        component: () => import('./pages/Activity.vue')
    },
    {
        path: '/faq',
        name: 'faq',
        meta: { requiresUnauth: true },
        component: () => import('./pages/Faq.vue')
    },
    {
        path: '/grocery-list',
        name: 'groceryList',
        component: () => import('./pages/GroceryList.vue'),
        meta: {
            breadcrumb: [{ parent: 'recipes', label: 'Shopping List' }],
            requiresAuth: true
        },
    },
    {
        path: '/login',
        name: 'login',
        meta: { requiresUnauth: true },
        component: () => import('./pages/Login.vue')
        
    },
    {
        path: '/error',
        name: 'error',
        meta: { requiresUnauth: true },
        component: () => import('./pages/Error.vue')
    },
    {
        path: '/notfound',
        name: 'notfound',
        meta: { requiresUnauth: true },
        component: () => import('./pages/NotFound.vue')
    },
    { 
        path: '/:pathMatch(.*)*', 
        name: 'not-found', 
        component: () => import('./pages/NotFound.vue'),
        meta: { requiresUnauth: true },
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    mode: 'history',
    routes
});

router.beforeEach(async function (to, from, next) {
    let appLogin = false;
    let str = window.location.hash;
    if (to.name === "login") {
        var query_secret = str.match(/secret=([^&]*)/);
        var query_account_id = str.match(/account_id=([^&]*)/);
        var redirect = str.match(/redirect=([^&]*)/);
        if (query_secret!=null && query_secret[1] === secret) {
            await getListPublicUsers(query_account_id[1]).then(async result => {
                await loginService.login(result[0].email, passwd).then(async (data) => {
                    store.commit("userdata/loginData", {
                        email: result[0].email,
                        ...data,
                    });
                    appLogin = true;
                    if (redirect == null) {
                        next({ name: 'dashboard' });
                    } else {
                        next({ name: 'profile' });
                    }
                })
            });
        }
    }
    if (appLogin === false){
        if (to.meta.requiresAuth && store.getters['login/getAccessToken'] === null) {
            next('/login');
        } else {
            next();
        }
    }
});

export default router;